import DTO from './DTO';

class MetaDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'limit',
        type: String,
      },
      {
        name: 'page',
        type: String,
      },
      {
        name: 'total',
        type: String,
      },
      {
        name: 'pages',
        type: String,
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default MetaDTO;
